import React from 'react';
import { AdvancedImage, responsive } from '@cloudinary/react';
import { RichLink } from '@naf-simba/sections-rich-link';
import { useDispatch } from 'react-redux';
import { DEFAULT_IMG_URL } from '@lib/constants';
import { actions } from '@redux/modules/user';
import { CarSearchResultType } from '@appTypes/GlobalSearchTypes';
import { getMediaProps } from './utils/getMediaProps';
import { useResolveLink } from '../../hooks/useResolveLink';
import { enableScroll } from '../../hooks/useScrollBlock';
import { useCloudinary } from '../../hooks/Cloudinary/useCloudinary';
import { useTrackSearchResultClick } from '../../hooks/useTrackSearchResultClick';

interface Props {
  item: CarSearchResultType;
}

export const CarSearchResultCard = ({ item }: Props) => {
  const dispatch = useDispatch();
  const { getResponsiveImage } = useCloudinary();
  const { trackClickSearchResult } = useTrackSearchResultClick();

  const href = item.url?.raw;
  const title = item.naf_page_title?.raw || '';
  const text = item.naf_page_description?.raw || 'Les mer om bilen';
  const altText = item.naf_page_title?.raw ? `Bilde av ${item.naf_page_title.raw}` : 'Bilde av bil';
  const carModelImageUrl = item.car_model_image?.raw;
  const { isInternal, linkProps } = useResolveLink(href);

  let advancedImage;
  let imgProp;

  if (carModelImageUrl) {
    const cldImage = getResponsiveImage(carModelImageUrl);
    advancedImage = <AdvancedImage cldImg={cldImage} plugins={[responsive({ steps: 200 })]} />;
    imgProp = {
      src: cldImage.toURL(),
      alt: altText,
    };
  } else {
    imgProp = {
      src: DEFAULT_IMG_URL,
      alt: altText,
    };
  }

  const media = getMediaProps(advancedImage, imgProp);

  const handleOnClick = () => {
    trackClickSearchResult();
    dispatch(actions.closeMenu());
    enableScroll();
  };

  const description = text || undefined;

  if (isInternal && linkProps.to) {
    return (
      <li key={item.id.raw}>
        <RichLink
          to={linkProps.to}
          title={title}
          description={description}
          media={media}
          variant="standard"
          onClick={handleOnClick}
        />
      </li>
    );
  }

  if (href) {
    return (
      <li key={item.id.raw}>
        <RichLink href={href} title={title} description={description} media={media} variant="standard" />
      </li>
    );
  }

  return null;
};
